// extracted by mini-css-extract-plugin
export default {"box":"circularPercentage_box__wjGtr"};